export const TAG_TYPES = {
  imported: 0,
  created: 1,
};

export const MAX_TAG_NAME_LENGTH = 20;
